module.exports = __webpack_public_path__ + "static/media/img6.13ac8444.jpg";